export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7299.e8039d4b.jpg";